import type { StateCreator } from 'zustand';
import type { StoreState } from './index';
import { viewConfigApi, VIEW_PAGE_FRAUD0, type ViewConfig } from '../services/viewConfigApi';

export interface ViewConfigSlice {
  viewConfig: Record<string, ViewConfig>;   // keyed by page
  fetchViewConfig: (page?: string) => Promise<void>;
}

export const createViewConfigSlice: StateCreator<StoreState, [], [], ViewConfigSlice> = (set) => ({
  viewConfig: {},

  fetchViewConfig: async (page = VIEW_PAGE_FRAUD0) => {
    try {
      const cfg = await viewConfigApi.getEffective(page);
      set((s) => ({ viewConfig: { ...s.viewConfig, [page]: cfg } }));
    } catch {
      // best-effort: keep whatever we had. Fraud0Leads falls back to "show all" when absent.
    }
  },
});
